import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bi bi-exclamation-triangle me-2" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-row flex-wrap gap-1"
}
const _hoisted_5 = { class: "d-flex flex-row gap-1" }
const _hoisted_6 = ["disabled", "title", "onClick"]
const _hoisted_7 = ["disabled", "title", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "title", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["disabled", "title", "onClick"]
const _hoisted_14 = ["disabled", "title", "onClick"]
const _hoisted_15 = ["disabled", "title", "onClick"]
const _hoisted_16 = ["disabled", "title", "onClick"]
const _hoisted_17 = ["disabled", "title", "onClick"]
const _hoisted_18 = ["disabled", "title", "onClick"]
const _hoisted_19 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_20 = ["disabled", "title", "onClick"]
const _hoisted_21 = ["disabled", "title", "onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["disabled", "title", "onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["disabled", "title", "onClick"]
const _hoisted_28 = ["disabled", "title", "onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-project-make-admin" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["disabled", "title", "onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-0",
    columns: this.columns,
    rowPosFactory: this.rowPosFactory,
    rowPosIncrementor: this.rowPosIncrementor,
    items: this.items,
    ref: "grid",
    idProperty: "projectId",
    storageKey: "projectListWidget"
  }, {
    network: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.networkName), 1)
    ]),
    projectDesignation: _withCtx(({ item }) => [
      _createTextVNode("(" + _toDisplayString(item.projectCode) + ") " + _toDisplayString(item.projectName), 1)
    ]),
    projectLeader: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.projectLeaderInfos, (projectLeaderInfo) => {
          return (_openBlock(), _createElementBlock("div", {
            key: projectLeaderInfo.organisationPerson.id
          }, _toDisplayString(projectLeaderInfo.person.givenName) + " " + _toDisplayString(projectLeaderInfo.person.surName), 1))
        }), 128))
      ])
    ]),
    created: _withCtx(({ item }) => [
      (item.projectCreated != null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$d(new Date(item.projectCreated * 1000), { dateStyle: 'short' })), 1),
            _createElementVNode("div", null, _toDisplayString(item.creator.givenName) + " " + _toDisplayString(item.creator.surName), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    route: _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(item.projectRouteName), 1)
    ]),
    status: _withCtx(({ item }) => [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('general.projectStatus.' + item.projectStatus)), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('general.projectAccess.' + item.projectAccess)), 1)
    ]),
    subProjectDesignation: _withCtx(({ item, rowPos, subProj = _ctx.getSubprojectForRowPos(item, rowPos) }) => [
      (item.subProjects.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("project.list.noSubProject")), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(!subProj.readOnly?'mt-1':'mt-1 linethrough')
            }, " (" + _toDisplayString(subProj.code) + _toDisplayString(subProj.number ?? "") + ") " + _toDisplayString(subProj.name), 3),
            _createElementVNode("div", _hoisted_5, [
              (item.mayReadWriteSubProject)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    disabled: this.disabled,
                    class: "btn btn-sm btn-outline-primary",
                    "data-bs-toggle": "tooltip",
                    title: this.getSubProjectReadWriteToolTip(item.subProjects[rowPos.getSubRow(0)]),
                    onClick: (() => {
                      let subProject = item.subProjects[rowPos.getSubRow()];
                      return () => _ctx.toggleSubProjectReadWrite(subProject);
                      })()
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(this.getSubProjectReadWriteIconClass(item.subProjects[rowPos.getSubRow(0)]))
                    }, null, 2)
                  ], 8, _hoisted_6))
                : _createCommentVNode("", true),
              (item.mayDeleteSubProject)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    disabled: this.disabled,
                    class: "btn btn-sm btn-outline-danger",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.$t('project.list.subProject.delete'),
                    onClick: (() => {
                      let subProject = item.subProjects[rowPos.getSubRow()];
                      return () => _ctx.deleteSubProject(subProject);
                      })()
                  }, _hoisted_9, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (item.mayEditSubProject)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    disabled: this.disabled,
                    class: "btn btn-sm btn-outline-primary",
                    "data-bs-toggle": "tooltip",
                    title: _ctx.$t('project.list.subProject.edit'),
                    onClick: (() => {
                      let subProject = item.subProjects[rowPos.getSubRow()];
                      return () => _ctx.editSubProject(subProject);
                      })()
                  }, _hoisted_12, 8, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    comment: _withCtx(({ item, rowPos }) => [
      (item.subProjects != null && item.subProjects.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (item.mayOpenObjectList)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary cic-svg objekte me-2 sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.list.subProject.jumpToObjectList'),
                  onClick: (() => {
                  let subProject = item.subProjects[rowPos.getSubRow()];
                  return () => _ctx.jumpToObjectList(item, subProject);
                  })()
                }, null, 8, _hoisted_13))
              : _createCommentVNode("", true),
            (item.mayOpenReviewCycleInstancesOverview)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary cic-svg pruefblatt me-2 sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.list.subProject.jumpToReviewCycle'),
                  onClick: (() => {
                  let subProject = item.subProjects[rowPos.getSubRow()];
                  return () => _ctx.jumpToReviewCycle(item, subProject);
                  })()
                }, null, 8, _hoisted_14))
              : _createCommentVNode("", true),
            (item.mayOpenPlanDeliverCatalogue)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary cic-svg planlieferkatalog me-2 sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.list.subProject.jumpToPlanDeliverCatalogue'),
                  onClick: (() => {
                  let subProject = item.subProjects[rowPos.getSubRow()];
                  return () => _ctx.jumpToPlanDeliverCatalogue(item, subProject);
                  })()
                }, null, 8, _hoisted_15))
              : _createCommentVNode("", true),
            (item.mayOpenDocumentList)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary cic-svg planverzeichnis me-2 sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.list.subProject.jumpToDocumentList'),
                  onClick: (() => {
                  let subProject = item.subProjects[rowPos.getSubRow()];
                  return () => _ctx.jumpToDocumentList(item, subProject);
                  })()
                }, null, 8, _hoisted_16))
              : _createCommentVNode("", true),
            (this.showAsBuiltSubProjects(item, rowPos))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 4,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary cic-svg bestandObj me-2 sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.list.subProject.jumpToAsBuildObjList'),
                  onClick: (() => {
                  let subProject = item.subProjects[rowPos.getSubRow()];
                  return () => _ctx.jumpToBPObjList(item, subProject);
                  })()
                }, null, 8, _hoisted_17))
              : _createCommentVNode("", true),
            (this.showAsBuiltDocuments(item, rowPos))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 5,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary cic-svg bestandDoc sm",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.list.subProject.jumpToAsBuildDocList'),
                  onClick: (() => {
                  let subProject = item.subProjects[rowPos.getSubRow()];
                  return () => _ctx.jumpToBPDocList(item, subProject);
                  })()
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_19, [
        (item.mayShowParticipations)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: this.disabled,
              class: "btn btn-sm btn-outline-secondary cic-svg projektbeteiligte sm",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('project.list.participationsToolTip'),
              onClick: ($event: any) => (_ctx.openParticipationPage(item))
            }, null, 8, _hoisted_20))
          : _createCommentVNode("", true),
        (item.mayAddSubProject)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              disabled: this.disabled,
              class: "btn btn-sm btn-primary",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('project.list.subProject.add'),
              onClick: ($event: any) => (_ctx.addSubProject(item))
            }, _hoisted_23, 8, _hoisted_21))
          : _createCommentVNode("", true),
        (item.mayEditProject)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              disabled: this.disabled,
              class: "btn btn-sm btn-outline-primary",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('project.list.edit'),
              onClick: ($event: any) => (_ctx.editProject(item))
            }, _hoisted_26, 8, _hoisted_24))
          : _createCommentVNode("", true),
        (this.isActive(item) && item.mayChangeAccess)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "btn btn-sm btn-outline-secondary",
              disabled: this.disabled,
              "data-bs-toggle": "tooltip",
              title: this.getAccessTitle(item),
              onClick: ($event: any) => (_ctx.changeProjectAccess(item))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(this.getAccessIcon(item))
              }, null, 2)
            ], 8, _hoisted_27))
          : _createCommentVNode("", true),
        (!item.isProjectAdmin && !this.isInactive(item) && item.mayMakeProjectAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              class: "btn btn-sm btn-outline-secondary",
              disabled: this.disabled,
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('project.list.makeProjectAdmin'),
              onClick: ($event: any) => (_ctx.makeProjectAdmin(item))
            }, _hoisted_30, 8, _hoisted_28))
          : _createCommentVNode("", true),
        (item.mayDeleteProject)
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              disabled: this.disabled,
              class: "btn btn-sm btn-outline-danger",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('project.list.delete'),
              onClick: (() => {
                        return () => _ctx.deleteProject(item);
                        })()
            }, _hoisted_33, 8, _hoisted_31))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["columns", "rowPosFactory", "rowPosIncrementor", "items"]))
}